
import React from "react";
import { Card } from "@/components/ui/card";
import { Loader2, Slack } from "lucide-react";

export const IntegrationLoading: React.FC = () => {
  return (
    <Card className="p-6 shadow-sm border bg-card">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Slack className="h-5 w-5 text-blue-500" />
          <h3 className="text-lg font-medium">Slack Integration</h3>
        </div>
      </div>
      <div className="h-32 flex items-center justify-center">
        <div className="flex flex-col items-center gap-2">
          <Loader2 className="h-8 w-8 text-primary animate-spin" />
          <p className="text-muted-foreground">Checking connection status...</p>
        </div>
      </div>
    </Card>
  );
};
